var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-to-speech"})
}
var staticRenderFns = []

export { render, staticRenderFns }